// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts';

export let DirectAccountOperationInfoMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_ACCOUNT_OPERATION_REQUEST_INFO_MESSAGE)
    this.RequestId;
    this.AccountId;
    this.CounterId;
    this.AssetId;
    this.Comment;

    this.LastUpdateTime;
    this.OperationType;
    this.Mode;
    this.Amount;
    this.CrossPrice;
}